import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import * as SelectPrimitives from '@radix-ui/react-select';
const SelectValue = SelectPrimitives.SelectValue;
const SelectTrigger = SelectPrimitives.SelectTrigger;
const SelectOptionText = SelectPrimitives.SelectItemText;
const SelectViewport = SelectPrimitives.SelectViewport;
const SelectIcon = SelectPrimitives.SelectIcon;
const SelectContent = SelectPrimitives.SelectContent;
const SortSelect = (props) => {
    const { defaultValue, value, onValueChange, ...sortSelectProps } = props;
    const newValueChange = useCallback((currentValue) => {
        if (onValueChange) {
            onValueChange({ name: currentValue });
        }
    }, [onValueChange]);
    return (_jsx(SelectPrimitives.Root, { value: value, defaultValue: defaultValue, onValueChange: newValueChange, ...sortSelectProps }));
};
const SelectOption = (props) => {
    const { value: { name, label }, ...optionProps } = props;
    return _jsx(SelectPrimitives.SelectItem, { value: name, textValue: label, ...optionProps });
};
SelectOption.displayName = 'SortSelectOption';
const Root = SortSelect;
const Option = SelectOption;
const OptionText = SelectOptionText;
const Viewport = SelectViewport;
const Icon = SelectIcon;
const Trigger = SelectTrigger;
const Value = SelectValue;
const Content = SelectContent;
export { Root, Option, OptionText, Viewport, Icon, Trigger, Value, Content, SortSelect, SelectValue, SelectTrigger, SelectOption, SelectOptionText, SelectViewport, SelectIcon, SelectContent, };
